import { Tabs, Typography } from 'antd'

import { ActiveUsersTab } from './tabs/ActiveUsersTab/ActiveUsersTab'
import { BillablesTab } from './tabs/BillablesTab/BillablesTab'
import { ConnectedUsersTab } from './tabs/ConnectedUsersTab/ConnectedUsersTab'

export const ReportDashboardPage = () => {
    return (
        <>
            <Typography.Title level={1}>Current Reports</Typography.Title>
            <Tabs style={{ padding: '20px' }}>
                <Tabs.TabPane tab="Connected Users" key="connected-users">
                    <ConnectedUsersTab />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Active Users" key="active-users">
                    <ActiveUsersTab />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Billable Actions" key="billables-tab">
                    <BillablesTab />
                </Tabs.TabPane>
            </Tabs>
        </>
    )
}
